<template>
  <div style="background: white;padding:20px;margin-bottom:20px;">
    <el-row :gutter="20" style="margin-bottom: 0;">
      <el-col :span="24">
        <div>{{cardData.month}}月商机数量</div>
      </el-col>
    </el-row>
    <el-row v-if="cardData.time" :gutter="20" style="height: 130px;">
      <el-col :span="12">
        <div class="t-lgray" style="font-size:12px;">{{cardData.time}} 更新</div>
        <div style="font-weight: bolder;font-size:50px;">{{cardData.new_clue_count}}</div>
        <el-button class="t-blue" size="medium" @click="$emit('ranking')">查看统计与排行</el-button>
      </el-col>
      <el-col :span="12" style="font-size: 14px;">
        <div class="t-gray pd-b-5">本月签约 <span class="t-black" style="margin-left:10px;">{{cardData.contract_clue}}</span></div>
        <div class="t-gray pd-b-5">本月启动 <span class="t-green" style="margin-left:10px;">{{cardData.start_clue}}</span></div>
        <div class="t-gray pd-b-5">本月输单 <span class="t-red" style="margin-left:10px;">{{cardData.lose_clue}}</span></div>
        <div class="t-gray pd-b-5">上月数量 <span class="t-black" style="margin-left:10px;">{{cardData.last_month_clue_count}}</span></div>
        <div class="t-gray pd-b-5">环比增长 <span :class="cardData.link_relative_ratio > 0 ? 't-green':'t-red'" style="margin-left:10px;">{{cardData.link_relative_ratio}}%</span></div>

      </el-col>

    </el-row>
    <el-empty v-else style="height: 130px" :image-size="80" description="暂无数据"></el-empty>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import {getclueInfo, getThisMonthClue} from "@/api/api";
export default {
  name: "ClueCountCard",
  props:['refreshCount'],
  data(){
    return {
      loading:false,
      cardData: {
        month:dayjs().month()+1,
        time:"",
        new_clue_count:0,
        contract_clue:0,
        start_clue:0,
        lose_clue:0,
        last_month_clue_count:0,
        link_relative_ratio:0
      },
    }
  },
  mounted() {
    this.refresh(false)
  },
  watch: {
    refreshCount() {
      this.refresh()
    },
  },
  methods:{
    async getData(){

      let postData = {
      }
      let res = await getThisMonthClue(postData)
      let resData = res.respData
      Object.assign(this.cardData,resData)
      this.loading = false
      // console.log('clueInfoDetail',resData,this.cardData)
    },

    async refresh(loading=true){
      this.loading = loading
      await this.getData()
    }
  }
}
</script>

<style scoped>

</style>
